<script setup>
import MainModal from "@/package/components/MainModal.vue";
import { computed } from "vue";
import MainButton from "@/components/helpers/MainButton.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["input"]);

const _modelValue = computed({
  get: () => props.value,
  set: (value) => {
    emit("input", value);
  },
});
</script>

<template>
  <MainModal :show-modal="_modelValue" @close="_modelValue = false">
    <div class="change-price-modal">
      <div class="change-price-modal__icon-container">
        <span class="icon-circle-info" />
      </div>

      <div class="change-price-modal__main-info">
        <h3>Цена обновилась</h3>
        <p>
          Стоимость тарифа изменилась. Проверьте обновлённую стоимость перед
          оплатой
        </p>
      </div>

      <MainButton title="Понятно" color="dark" @click="_modelValue = false" />
    </div>
  </MainModal>
</template>

<style scoped lang="scss">
:deep(.main-modal__container) {
  padding: 48px !important;
}

.change-price-modal {
  width: 324px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  &__icon-container {
    margin: 0 auto;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: var(--gold-secondary, #ffe5a2);
    display: flex;
    align-items: center;
    justify-content: center;

    > span {
      width: 40px;
      height: 40px;
      background-color: $dark-primary;
    }
  }

  &__main-info {
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 8px;

    > h3 {
      color: var(--text-dark-primary, #212121);
      @include title-3;
    }

    > p {
      color: var(--text-dark-primary, #212121);
      @include text-2;
    }
  }
}

@media (max-width: 767px) {
  :deep(.main-modal__container) {
    padding: 24px 20px !important;
  }

  .change-price-modal {
    width: 100%;
    padding-top: 24px;
  }
}
</style>
